import { useMutation, useQueryClient } from '@tanstack/react-query'
import { IChecklist } from '@core/entities/checklist/Checklist'
import {
  checklistKeys,
  RequestTypes,
} from '@core/react-query/features/checklists/checklist'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useNominateChecklistApprovers = () => {
  const queryClient = useQueryClient()

  return useMutation<
    IChecklist,
    RequestErrorType,
    RequestTypes['nominateApprovers']
  >({
    ...checklistKeys.nominateApprovers,
    onSuccess: (checklist) => {
      queryClient.setQueryData(
        checklistKeys.byId({ checklistId: checklist.id }).queryKey,
        checklist,
      )
    },
  })
}
